import Ajax from './Ajax.js'

const Config = {
  getConfigPrivateKey: () => {
    return Ajax.get(`/config/private-key`);
  },
  getConfig: async () => {
    const res = await Ajax.get('/config');
    const data = res.data?.data || res.data;
    if (data) {
      data.contract_address = data.contract_address || data.contractAddress;
      data.token_contract_address = data.token_contract_address || data.tokenContractAddress;
      data.json_rpc_provider = data.json_rpc_provider || data.jsonRpcProvider;
      data.token_id_url_template = data.token_id_url_template || data.tokenIdUrlTemplate;
      data.tx_url_template = data.tx_url_template || data.txUrlTemplate;
      data.wallet_address = data.wallet_address || data.walletAddress;
      data.locked_token_contract_address = data.locked_token_contract_address || data.lockedTokenContractAddress;
      data.marketplace_contract_address = data.marketplace_contract_address || data.marketplaceContractAddress;
      data.marketplace_json_rpc_provider = data.marketplace_json_rpc_provider || data.marketplaceJsonRpcProvider;
    }
    return { ...res, data };
  },
  putConfig: (params) => {
    const id = params.id
    const data = { ...params }
    delete data.id
    const payload = params && params.data ? params : { data }
    return Ajax.put('/config/' + id, payload)
  },
  delConfig: (id) => {
    return Ajax.delete('/config/' + id)
  }
}

export default Config
